(function( $ ) {

    function menuPosition(){
        cordMenu = $('.menu-icon-box').offset();
        var greenMenu = $(".green-menu");
        if(greenMenu.hasClass('opened')){
            greenMenu.css({"left": cordMenu.left+"px"});
        }
    }

    $(function() {

        menuPosition();

        //Hamburger Menu
        $('#nav-icon3').click(function(){
            var greenMenu = $(".green-menu");
            $(this).toggleClass('open');
            greenMenu.toggleClass('opened');
            if(greenMenu.hasClass('opened')){
                greenMenu.css({"left": cordMenu.left+"px"});
            }else {
                greenMenu.css({"left": 100+'%'});
            }
        });

        //Make elements equal height
        $('footer > .row > .columns').matchHeight();
        $('.logo-box').matchHeight();

        /// Filter
        $('.search-btn').click(function(){
            var url = window.location.origin+window.location.pathname;
            url += '?';
            $('.partners option').each(function(){
                var name = $('.partners').attr("name");
                var value = $(this).val();
                if($(this).is(":selected")){
                    if( value.length > 0 && value != 'partners') {
                        url += name + '=' + value + '&';
                    }
                }
            });
            $('.voor-wie option').each(function(){
                var name = $('.voor-wie').attr("name");
                var value = $(this).val();
                if($(this).is(":selected")){
                    if( value.length > 0 && value != 'voor-wie') {
                        url += name + '=' + value + '&';
                    }
                }
            });
            $('.thema option').each(function(){
                var name = $('.thema').attr("name");
                var value = $(this).val();
                if($(this).is(":selected")){
                    if( value.length > 0 && value != 'thema') {
                        url += name + '=' + value + '&';
                    }
                }
            });
            $('.voorwaarden option').each(function(){
                var name = $('.voorwaarden').attr("name");
                var value = $(this).val();
                if($(this).is(":selected")){
                    if( value.length > 0 && value != 'voorwaarden') {
                        url += name + '=' + value + '&';
                    }
                }
            });
            // remove last &
            url = url.slice(0, -1);
            // reload page
            window.location.replace( url );

        });

        // Project Hover
        $('.project-box').hover(function() {
            $(this).find('.pro-hover').fadeIn(250);
        },function(){
            $(this).find('.pro-hover').fadeOut(250);
        });

    });

    $(window).resize(function(){
        menuPosition();
    });

})(jQuery);